import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import axios from "axios";
import { useNavigate } from "react-router-dom";

// // Clear clientMongoId from localStorage on every refresh
// window.addEventListener("load", () => {
//   localStorage.removeItem("clientMongoId");
// });

const AdminLogin = ({ onBack }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false); // <-- Add this state
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const res = await axios.get("https://studio-lc.onrender.com/api/clients");
      // Find a client with matching username and password
      const admin = res.data.find(
        (c) => c.username === username && c.password === password
      );
      if (admin) {
        localStorage.setItem("studioName", admin.studio);
        localStorage.setItem("clientMongoId", admin._id); // Save MongoDB _id
        console.log("Login - clientMongoId:", admin._id); // <-- Print login id
        navigate("/admin-home");
      } else {
        setError("Invalid username or password");
      }
    } catch (err) {
      setError("Login failed. Try again.");
    }
  };

  return (
    <Box>
      <Typography
        variant="h6"
        fontWeight="bold"
        sx={{
          fontFamily: "Josefin Sans",
          fontSize: { xs: "1.5rem", sm: "1.7rem", md: "1.7rem" },
          mb: 2,
          textAlign: "center",
        }}
      >
        Admin Login
      </Typography>
      <Box
        component="form"
        onSubmit={handleSubmit}
        display="flex"
        flexDirection="column"
        gap={2}
      >
        <TextField
          label="Username"
          variant="outlined"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
          fullWidth
        />
        <TextField
          label="Password"
          variant="outlined"
          type={showPassword ? "text" : "password"}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          fullWidth
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label={showPassword ? "Hide password" : "Show password"}
                  onClick={() => setShowPassword((show) => !show)}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        {error && (
          <Typography color="error" sx={{ textAlign: "center" }}>
            {error}
          </Typography>
        )}
        <Button
          sx={{ fontFamily: "Josefin Sans" }}
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
        >
          Submit
        </Button>
        <Button
          sx={{ fontFamily: "Josefin Sans" }}
          variant="text"
          color="secondary"
          fullWidth
          onClick={onBack}
        >
          Back
        </Button>
      </Box>
    </Box>
  );
};

export default AdminLogin;